export default __webpack_public_path__ + "locales/it/JavascriptSdk.json?hash=33e8148a0aa7a0bd704f389152eebead";